<template>
    <!-- Mount VolunteerInfo invisibly so it always kicks off the volunteer data fetch -->
    <VolunteerInfo v-if="currentFD"></VolunteerInfo>

    <NextOrTodaysFD></NextOrTodaysFD>

    <div v-if="!!error" class="notification is-danger is-light">
        <p>{{ error }}</p>
    </div>

    <!-- Show a single spinner while FD or volunteer data hasn't arrived yet -->
    <base-spinner v-if="isInitializing"></base-spinner>

    <div class="main" v-else-if="currentFD">
        <div v-if="currentFD.status == 'DRAFT'">
            <div v-if="volunteerData">
                <SignUpSuccessMessage></SignUpSuccessMessage>
            </div>
            <div v-else class="box has-text-centered mt-4">
                <p class="mb-4" style="color: #374151;">Spots are open — join us this Saturday!</p>
                <router-link :to="'/volunteer/' + currentFD.id">
                    <button class="button is-info is-rounded is-large">Sign Up to Volunteer</button>
                </router-link>
            </div>
        </div>
        <div v-if="currentFD.status == 'LIVE'">
            <VolunteerDelivery></VolunteerDelivery>
        </div>
        <div v-if="currentFD.status == 'CLOSED'" class="notification is-info">
            <div v-if="volunteerData">
                <p>Today's FD is completed.</p>
                <p> Thank you for your support! 😊</p>
                <br>
                <p>If you have any feedback or suggestion, please send us an email: <a href="mailto:apexbt@apex.org.sg">apexbt@apex.org.sg</a>.</p>
            </div>
            <div v-else>
                <p>Please come back to volunteer in the future! 😊</p>
            </div>
        </div>
    </div>
</template>

<script>
import NextOrTodaysFD from '@/components/fd/NextOrTodaysFD.vue';
import VolunteerInfo from '@/components/volunteer/VolunteerInfo.vue';
import VolunteerDelivery from '@/components/delivery/VolunteerDelivery.vue';
import SignUpSuccessMessage from '../volunteer/SignUpSuccessMessage.vue';

export default {
    components: {
        NextOrTodaysFD,
        VolunteerInfo,
        VolunteerDelivery,
        SignUpSuccessMessage
    },
    data() {
        return {
            error: null,
        }
    },
    computed: {
        currentFD() {
            return this.$store.getters['fd/getCurrentFD'];
        },
        volunteerData() {
            return this.$store.getters['volunteer/getVolunteerData'];
        },
        volunteerDataResolved() {
            return this.$store.getters['volunteer/isVolunteerDataResolved'];
        },
        isInitializing() {
            // Still loading if we don't know the FD yet, or if the FD needs volunteer
            // data (LIVE/DRAFT/CLOSED all show volunteer-dependent UI) and it hasn't arrived.
            if (!this.currentFD) return false; // NextOrTodaysFD handles the no-FD state
            return !this.volunteerDataResolved;
        }
    }
}
</script>